export let props = ['width', 'height', 'plateNumber', 'plateColor', 'inside', 'fontSize', 'carType',
  'justify',
  'unClickAble',
]
export let model = {
  get plateColorOptions () {
    let result = {}
    window.utils.dict.get('dict_LicenseColor_option').forEach(item => {
      let color = undefined
      try{
        color = JSON.parse(item.additional).color
      } catch(e) {
        console.log('字典分组：carNumberColour 中字典名' + item.dictName + '的附加值格式不是JSON')
      }
      result[item.dictValue] = color
    })
    return result
  }
}
export let computed = {
  plateColorValue () {
    return this.plateColorOptions[this.plateColor]
  }
}
